/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { FieldTypeEnum } from './fieldTypeEnum';
import { HistoryModelTypeEnum } from './historyModelTypeEnum';

export interface HistoryChangeItem { 
    historyModelType: HistoryModelTypeEnum;
    recordId: string;
    isCurrent: boolean;
    isLocked: boolean;
    validFrom: string;
    fieldName: string;
    fieldDisplayText?: string;
    fieldType: FieldTypeEnum;
    fieldOptions?: any;
    oldValue?: any;
    newValue?: any;
    oldValueDisplayText?: any;
    newValueDisplayText?: any;
    firstFutureValue?: any;
    firstFutureValueDisplayText?: any;
    firstFutureValueDate?: string;
}